import React, { memo } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import useHeaderTheme from 'Components/hooks/use-header-theme'

const HeaderLogo = memo(() => {
  const headerTheme = useHeaderTheme()

  return (
    <React.Fragment>
      <a
        target={'_blank'}
        className="logo"
        title="懂车帝logo"
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'dcar_brand_icon',
          })
        }}
        href={'/'}
      >
        <img
          className="tw-h-32 tw-w-auto lg:tw-h-36 xl:tw-h-46"
          src={
            headerTheme === 'theater'
              ? require('static/black-logo.png')
              : require('static/logo.svg')
          }
          width={141}
          height={46}
          alt="懂车帝logo"
        />
      </a>
    </React.Fragment>
  )
})

export default HeaderLogo
